import { Button, Card, Heading, Text } from "@/design-system";
import { PageSection } from "@/pages/landingPage/components/pageSection";
import { Link } from "react-router";

type CalculatorCtaProps = {
  id: string;
  title: string;
  text: string;
  href: string;
  ctaLabel: string;
};

/** CTA de baixo atrito: leva a uma ferramenta grátis de `/ferramentas`. */
export const CalculatorCta = ({
  id,
  title,
  text,
  href,
  ctaLabel,
}: CalculatorCtaProps) => (
  <PageSection labelledBy={`${id}-title`}>
    <Card className="flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between sm:gap-8 md:p-8">
      <div className="flex flex-col gap-2">
        <Heading level={2} size={3} id={`${id}-title`}>
          {title}
        </Heading>
        <Text tone="muted">{text}</Text>
      </div>
      <Button asChild variant="secondary" size="lg" navigates="internal">
        <Link to={href}>{ctaLabel}</Link>
      </Button>
    </Card>
  </PageSection>
);
